module.exports = __webpack_public_path__ + "static/media/11.60611a06.png";